<mat-card>
    <div class="product-wrapper" style="position: relative" *ngIf="stateData?.price_with_assistance">
        <div class="product-header" *ngIf="stateData?.withAssistance">
            <h3>Seguro a terceros con asistencia</h3>
            <div class="price-container">{{ stateData?.price_with_assistance?.primaTotal | number:'1.2-2' }} €</div>
        </div>
        <div class="product-header" *ngIf="!stateData?.withAssistance">
            <h3>Seguro a terceros</h3>
            <div class="price-container">{{ stateData?.price_without_assistance?.primaTotal | number:'1.2-2' }} €</div>
        </div>
        <div class="preview-data-wrapper">
            <div class="preview-data-item">
                <span class="preview-data-label">Días contratados</span>
                <span class="preview-data-value">{{ stateData?.duration }} {{ stateData?.duration > 1 ? 'días' : 'día'
                    }}</span>
                <mat-icon class="edit-icon" (click)="goToForm()">edit</mat-icon>
            </div>
            <div class="preview-data-item">
                <span class="preview-data-label">Fecha de inicio - fin del seguro</span>
                <span class="preview-data-value">{{ stateData?.start_date | date }} - {{ stateData?.end_date | date
                    }}</span>
                <mat-icon class="edit-icon" (click)="goToForm()">edit</mat-icon>
            </div>
            <div class="preview-data-item">
                <span class="preview-data-label">Vehículo</span>
                <span class="preview-data-value">{{ stateData?.brandName }} {{ stateData?.modelName }}</span>
                <mat-icon class="edit-icon" (click)="goToHome()">edit</mat-icon>
            </div>
            <div class="preview-data-item">
                <span class="preview-data-label">Matrícula</span>
                <span class="preview-data-value">{{ stateData?.licensePlate }}</span>
                <mat-icon class="edit-icon" (click)="goToHome()">edit</mat-icon>
            </div>
        </div>
        <div class="product-details">
            Incluye:
            <div class="product-detail" *ngFor="let detail of detailsData.all">
                <div class="product-detail-header">{{ detail.title }}
                    <mat-icon *ngIf="expandedDetail != detail.id"
                        (click)="expandedDetail = detail.id">expand_more</mat-icon>
                    <mat-icon *ngIf="expandedDetail == detail.id" (click)="expandedDetail = ''">expand_less</mat-icon>
                </div>
                <div class="product-detail-content" *ngIf="expandedDetail == detail.id">
                    <span [innerHTML]="detail.description"></span>
                </div>
            </div>
            <ng-container *ngIf="stateData?.withAssistance">
                <div class="product-detail" *ngFor="let detail of detailsData.optional">
                    <div class="product-detail-header">{{ detail.title }}
                        <mat-icon *ngIf="expandedDetail != detail.id"
                            (click)="expandedDetail = detail.id">expand_more</mat-icon>
                        <mat-icon *ngIf="expandedDetail == detail.id"
                            (click)="expandedDetail = ''">expand_less</mat-icon>
                    </div>
                    <div class="product-detail-content" *ngIf="expandedDetail == detail.id">
                        <span [innerHTML]="detail.description"></span>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
    <br />
    <div class="main-wrapper">
        <form [formGroup]="productResultForm">
            <mat-checkbox class="cover-checkbox" formControlName="checkCondiciones">
                He leído y acepto las <a href='https://www.coverpordias.es/legal/condicionado-seguro-por-dias.pdf'
                    target="_blank">condiciones legales</a> del seguro.
            </mat-checkbox>
            <mat-checkbox class="cover-checkbox" formControlName="checkAvisoLegal">
                He leído y acepto la <a href='https://www.coverpordias.es/legal/politica-de-privacidad.pdf'
                    target="_blank">política de privacidad</a> y el <a
                    href="https://www.coverpordias.es/legal/consentimiento-contratacion.pdf"
                    target="_blank">consentimiento</a>.
            </mat-checkbox>
            <mat-checkbox class="cover-checkbox" formControlName="checkCondicionesEspeciales">
                Entiendo las <a href='https://www.coverpordias.es/seguro-temporal-condiciones'
                    target="_blank">condiciones especiales</a> para este tipo de seguro.
            </mat-checkbox>
            <mat-checkbox class="cover-checkbox" formControlName="checkWhatsapp">
                Acepto que <a href='https://www.coverpordias.es/legal/aceptacion-whatsapp.pdf'
                    target="_blank">contactéis por WhatsApp</a> para temas relacionados con mi seguro.
            </mat-checkbox>
        </form>
        <br />
        <button mat-button mat-raised-button color="primary" (click)="contract()"
            [disabled]="productResultForm.invalid  || productResultForm.pending" style="width: 100% !important;">
            Contratar
        </button>
        <br /><br />
    </div>
</mat-card>